import type { Filter, FilterDataSearchDynamic } from '@/app/common/filters/core/filtersTypes';

export const FilterSearchDynamicPill = (filter: Filter): string[] => {
  const data = filter.data as FilterDataSearchDynamic;
  return data.value ? [String(data.value)] : [data.label];
};
